import swiper from '../utils/swiper.js';

export function selectedStayDates(url = window.location.href) {
    const value = new URL(url).searchParams.get('dates');
    if (!value || !value.includes(' to ')) return null;

    const [checkIn, checkOut] = value
        .split(' to ', 2)
        .map((date) => date.trim());

    return isIsoDate(checkIn) && isIsoDate(checkOut)
        ? { checkIn, checkOut }
        : null;
}

export function configuredStayDates(dataset = {}) {
    const checkIn = dataset.stayCheckIn ?? '';
    const checkOut = dataset.stayCheckOut ?? '';

    return isIsoDate(checkIn) && isIsoDate(checkOut)
        ? { checkIn, checkOut }
        : null;
}

export function eventOverlapsStay(eventStart, eventEnd, stay) {
    if (!stay || !isIsoDate(eventStart)) return false;

    const normalizedEnd = isIsoDate(eventEnd) ? eventEnd : eventStart;

    return eventStart <= stay.checkOut && normalizedEnd >= stay.checkIn;
}

function isIsoDate(value) {
    return /^\d{4}-\d{2}-\d{2}$/.test(value ?? '');
}

const guideCardsByRoot = new WeakMap();

function refreshCardCarousel(root, stay) {
    const section = root.querySelector(
        '[data-listing-local-guide-recommendations]'
    );
    const swiperElement = section?.querySelector('.swiper');
    const wrapper = section?.querySelector(
        '[data-listing-local-guide-card-slides]'
    );
    if (!section || !swiperElement || !wrapper) return;

    if (!guideCardsByRoot.has(root)) {
        guideCardsByRoot.set(
            root,
            Array.from(
                wrapper.querySelectorAll('[data-listing-local-guide-card]')
            ).map((slide) => slide.cloneNode(true))
        );
    }

    const templates = Array.from(
        root.querySelectorAll('[data-listing-local-guide-event]')
    );

    const matching = templates.filter((template) =>
        eventOverlapsStay(
            template.dataset.eventStart,
            template.dataset.eventEnd,
            stay
        )
    );

    if (swiperElement.swiper) {
        swiperElement.swiper.destroy(true, true);
    }

    const cardLimit = Math.max(1, Number(root.dataset.cardLimit) || 9);
    const eventSlides = matching.map((template) =>
        template.content.firstElementChild.cloneNode(true)
    );
    const guideSlides = guideCardsByRoot
        .get(root)
        .map((slide) => slide.cloneNode(true));
    const slides = [...eventSlides, ...guideSlides].slice(0, cardLimit);

    wrapper.replaceChildren(...slides);
    root.hidden = slides.length === 0;
    if (root.hidden) return;

    swiper.refresh(section);
}

const listingLocalGuide = {
    init() {
        const roots = Array.from(
            document.querySelectorAll('[data-listing-local-guide]')
        );
        if (roots.length === 0) return;

        const render = (fallbackStay) => {
            roots.forEach((root) => {
                const stay = configuredStayDates(root.dataset) ?? fallbackStay;
                refreshCardCarousel(root, stay);
            });
        };

        render(selectedStayDates());

        window.addEventListener('listing-booking-dates-changed', (event) => {
            const checkIn = event.detail?.checkIn ?? '';
            const checkOut = event.detail?.checkOut ?? '';
            const stay =
                isIsoDate(checkIn) && isIsoDate(checkOut)
                    ? { checkIn, checkOut }
                    : null;

            render(stay);
        });
    }
};

export default listingLocalGuide;
